<!--
 * @Descripttion: 实名信息，开户信息详情
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="auth-status">
    <BaseForm label-position="right">
      <div class="auth-status-title">经营者信息</div>
      <div style="display: flex">
        <div>
          <BaseFormItem prop="name" label="经营者">
            <BaseInput disabled :model-value="formData.name"></BaseInput>
          </BaseFormItem>
        </div>
        <div>
          <BaseFormItem prop="phone" label="手机号">
            <BaseInput disabled :model-value="formData.phone"></BaseInput>
          </BaseFormItem>
        </div>
      </div>
      <BaseFormItem prop="cardId" label="身份证号">
        <BaseInput disabled :model-value="formData.cardId"></BaseInput>
      </BaseFormItem>
      <BaseFormItem prop="cardIdFront" label="身份证照片">
        <BaseImage
          style="width: 180px; height: 100px; margin-right: 40px"
          :src="formData.cardIdFront"
          :preview-src-list="[formData.cardIdFront]"
        ></BaseImage>
        <BaseImage
          style="width: 180px; height: 100px"
          :src="formData.cardIdBack"
          :preview-src-list="[formData.cardIdBack]"
        ></BaseImage>
      </BaseFormItem>
      <BaseFormItem prop="bankCardNum" label="银行卡号">
        <BaseInput disabled :model-value="formData.bankCardNum"></BaseInput>
      </BaseFormItem>
      <BaseFormItem prop="bankInfo" label="银行名称">
        <BaseInput disabled :model-value="formData.bankInfo"></BaseInput>
      </BaseFormItem>

      <div class="auth-status-title">个体工商户信息</div>
      <BaseFormItem prop="individualName" label="个体名称">
        <BaseInput
          style="width: 468px"
          disabled
          :model-value="formData.individualName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem prop="cardIdFront" label="营业执照">
        <BaseImage
          style="width: 180px; height: 100px; margin-right: 40px"
          :src="formData.entpCertPic"
          :preview-src-list="[formData.entpCertPic]"
        ></BaseImage>
      </BaseFormItem>
      <BaseFormItem prop="entpCertType" label="个体工商户证件编码">
        <BaseSelect
          style="width: 468px"
          placeholder="请选择个体工商户证件编码"
          disabled
          :options="COMPANY_CERTIFICATE_CODE"
          :model-value="formData.entpCertType"
        ></BaseSelect>
        <BaseInput
          style="width: 468px; margin-top: 10px"
          placeholder="请输入对应的证件码"
          disabled
          :model-value="formData.entpCertNo"
        ></BaseInput>
      </BaseFormItem>
    </BaseForm>
  </div>
</template>

<script lang="tsx" setup>
import { ref, withDefaults, defineProps } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseImage,
  BaseSelect
} from 'xrk-components';
import { allianceUserRnv } from '../data-source/apis';

const COMPANY_CERTIFICATE_CODE = {
  1: { label: '统一社会信用代码', value: 1 },
  2: { label: '工商注册号', value: 2 }
};

// 声明 prop 属性
const props = withDefaults(
  defineProps<{
    userId: number;
  }>(),
  {
    userId: null
  }
);

const formData = ref({
  name: '',
  phone: '',
  cardId: '',
  cardIdFront: '',
  cardIdBack: '',
  bankCardNum: '',
  bankInfo: '',
  individualName: '',
  entpCertType: '',
  entpCertNo: '',
  entpCertPic: ''
});

const getInfo = async () => {
  const res: any = await allianceUserRnv({
    userId: props.userId
  });
  formData.value = res.data;
};
getInfo();
</script>
<style lang="scss">
.auth-status-title {
  font-weight: 600;
  font-size: 16px;
  position: relative;
  margin: 0 0 10px -20px;

  &::before {
    content: '';
    position: absolute;
    left: -15px;
    top: 5px;
    width: 5px;
    height: 16px;
    background: #fa8100;
  }
}
</style>
